/**
 * Formatting constants relating to dates, made from the global agnostic formats provided in moment-with-locales.js
 * E.g. from en-us.
 *     LTS  : 'h:mm:ss A',
 *     LT   : 'h:mm A',
 *     L    : 'MM/DD/YYYY',
 *     LL   : 'MMMM D, YYYY',
 *     LLL  : 'MMMM D, YYYY h:mm A',
 *     LLLL : 'dddd, MMMM D, YYYY h:mm A'
 *
 *  Formats below should never be in format like 'h:mm A', it should be 'LT' as the former would break globalization.
 */ export var DateFormat;
(function(DateFormat) {
    /** Format for display and parsing of dates in the grid */ DateFormat["GridDate"] = "l";
    /** mm/dd/yyyy */ DateFormat["ShortDateFormat"] = "L";
    /** MMMM D, YYYY */ DateFormat["LongDateFormat"] = "LL";
    /** mm/dd/yyyy hh/mm AM/OM */ DateFormat["DateTimeFormat"] = "L LT";
    /** Dates for Text fields from Project Server */ DateFormat["TextDateField"] = "l LT";
    /** MMMM D, YYYY h:mm A */ DateFormat["MonthDateTimeFormat"] = "LL LT";
})(DateFormat || (DateFormat = {}));
